<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="order_internal_no" [ttModel]="edit.order_internal_no" ttReadonly></tt-input>
        <tt-input ttLabel="project_name" [(ttModel)]="edit.project_name" ttRequired></tt-input>
        <tt-textarea ttLabel="description" [(ttModel)]="edit.description"></tt-textarea>
        <tt-select ttLabel="portal_user_keyno_project_manager" [(ttModel)]="edit.portal_user_keyno_project_manager" [ttData]="selectListProjectManagers" ttDataId="item_id" ttDataName="item_name" ttRequired></tt-select>
        <tt-button-save ttText="orderheadcreateproject_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
